<template>
  <CRow>
    <CCol>
    
     <CCard>
        <CCardHeader>
          Benutzer id:  {{ $route.params.id }}
        </CCardHeader>
        <CCardBody>
          <form
            @submit="checkForm"
            novalidate="true"
          >
            <div class="form-group">
              <label for="inputCustomerNo">Kundennummer</label>
              <input type="text" class="form-control" id="inputCustomerNo" v-model="userData.customerno" placeholder="">
            </div>
            <div class="form-group">
              <label for="inputCompany">Unternehmen</label>
              <input type="text" class="form-control" id="inputCompany" v-model="userData.company" placeholder="">
            </div>
            <div class="form-group">
              <label for="inputDisplayName">Anzeigename</label>
              <input type="text" class="form-control" id="inputDisplayName" v-model="userData.displayname" placeholder="">
            </div>
            <div class="form-group">
              <label for="inputEmail">E-Mail</label>
              <input type="text" class="form-control" id="inputEmail" v-model="userData.email" placeholder="">
            </div>
            <div class="form-group">
              <label for="inputUserName">Benutzername</label>
              <input type="text" class="form-control" id="inputUserName" v-model="userData.username" placeholder="">
            </div>
            <div class="form-group">
              <label for="inputPassword">Kenwort</label>
              <input type="password" class="form-control" id="inputPassword" ref="inputPassword" value="PASSWORDINVALID" placeholder="">
            </div>
            <div class="form-group">
              <label for="password">Kenwort wiederholen</label>
              <input type="password" class="form-control" id="inputPassword2" ref="inputPassword2" value="INVALIDPASSWORD" placeholder="">
            </div>
            <div class="form-group">
              <img :src="this.userData.picture_url" class="picture"/>
              <div style="height:60px; float: left;">
                <label for="files" class="btn btn-dark" >Bild auswählen</label>
                <input type="file" class="custom-file-input" id="files" ref="files" @change="handleUpload" placeholder="">
              </div>
            </div>

            <div class="form-group" style="clear:both;">
              <label for="inputUserMinCartValue">Bestellwert für Versandkostenfreiheit</label>
              <input type="text" class="form-control" id="inputUserMinCartValue" v-model="userData.mincartvalue" placeholder="">
            </div>
            
            <div class="form-group">
              <label for="inputUserParent">ID des Hauptbenutzers oder leer lassen</label>
              <input type="text" class="form-control" id="inputUserParent" v-model="userData.parent" placeholder="">
            </div>

          </form>
        </CCardBody>
      </CCard>
     
      <CCard>
        <CCardHeader>
          Gruppen Zugehörigkeit
        </CCardHeader>
        <CCardBody>
          <CDataTable
              hover
              striped
              tableFilter
              :filterable="false"
              sorter
              :items="usergrouplist"
              :fields="groupfields"
              :items-per-page="perPage"
              @row-clicked="groupRowDblClicked"
              :pagination="$options.paginationProps"
              index-column
              clickable-rows
            >
            <template #functions="{item}">
              <td>
                <toggle-button @change="toggle" :tag="item.id" v-bind:value="userInGroupList[item.id]" color="#82C7EB" :sync="true" :labels="{checked: 'Ja', unchecked: 'nein'}"/>
              </td>
            </template>
            </CDataTable>
            <!-- <button class="btn btn-success" @click="btnNewClicked">Neue Gruppe</button> -->
        </CCardBody>
        <CCardFooter>
          <CButton class="btn btn-danger" @click="goDelete">Löschen</CButton>&nbsp;
          <CButton class="btn btn-warning" @click="goBack">Abbrechen</CButton>&nbsp;
          <CButton class="btn btn-success" @click="goOK">OK</CButton>
        </CCardFooter>
      </CCard>
    
    </CCol>
  </CRow>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    name: 'User',
    data() {
      return {
        
  
        errors: [],
        uploadfile:'',
        groupfields: [
          { key: 'id', label: '#',sorter:true },
          { key: 'functions', label: 'Mitglied',sorter:true },
          { key: 'groupname', label: 'Gruppen Name',sorter:true },
          { key: 'groupdesc', label: 'GruppenBeschreibung',sorter:false }
        ],
        perPage: 20
      }
    },
    computed : {
      ...mapGetters(["usergrouplist","userInGroupList","userData"]),
      
    },
    created() {
    
      this.getUserData(this.$route.params.id);
      this.getUserGroupList('%');
      this.getUserInGroupList(this.$route.params.id);
      

    },
    mounted () {   
    },
    methods: {
      ...mapActions(['getUserGroupList','getUserInGroupList','getUserData']),
     
      async toggle(event) {
  
        const response = await this.$axios.post('/', {event:'usersetmembergroup',id:this.$route.params.id, groupid:event.tag, value: event.value } );
        this.getUserInGroupList(this.$route.params.id);
      },
      groupRowDblClicked () {},
      btnNewClicked () {},
      checkForm: function (e) {
        if (this.userData.inputUserName && this.userData.inputDisplayName) {
          return true;
        }

        this.errors = [];

        if (!this.userData.inputUserName) {
          this.errors.push('Es muss ein Benutzername gewählt werden.');
        }
        if (!this.userData.inputDisplayName) {
          this.errors.push('Es muss ein Anzeigename gewählt werden.');
        }

        e.preventDefault();
      },
      handleUpload() {
        this.uploadfile = this.$refs.files.files[0];   
      },
      goBack() {
        this.$router.go(-1)
      },
      goDelete() {
        if (confirm("Möchten sie diesen Benutzer tatsächlich löschen?")) {
          this.$axios.post('/',{event:'userdelete',id:this.$route.params.id})
          .then(response => { this.$router.go(-1) } ) 
          .catch(error => console.log(error))
        }
      },
      goOK() {
        let formData = new FormData();

        if (this.$refs.inputPassword.value!='PASSWORDINVALID') {
          if (this.$refs.inputPassword.value == this.$refs.inputPassword2.value) {

              this.userData['password'] = this.$refs.inputPassword.value;

          } else {

            alert("Die Passwörter stimmen nicht überein!");
            return false;

          }
        }

        formData.append('event', 'userput');
        formData.append('id', this.$route.params.id);
        formData.append('file', this.uploadfile);
        formData.append('userdata', JSON.stringify(this.userData)); //always encode objects
     
        this.$axios.post('/',formData,
          {
            headers: { 'Content-Type': 'multipart/form-data' }
          })
          .then(response => {
            var ajaxerror = response.data.error;
            if (ajaxerror == '') {
              this.uploadfile = ''; 
              this.$router.go(-1); 
            } else { 
              alert("Speichern nicht erfolgreich: " + ajaxerror); 
            }
          } ) 
          .catch(error => {
            console.log(error);
            alert("Speichern nicht erfolgreich: " + error);
          } )
      }
    }
  }
</script>
<style scoped>
  .picture {width: 100px; height:100px; border: 1px #aaa dashed; padding: 3px; margin-right:20px; float: left;}
  .custom-file-input { visibility: hidden; }
</style>
